<template>
  <div class="fd_body" v-if="body_show">
    <div class="task">
      <div class="task_e">
        竞争力提升策略与你选择的职位高度相关，请确认你需要辅导的目标职位。
      </div>
      <!-- 意向行业 -->
      <div class="task_f">
        <div class="input-box input-mt on">
          <van-cell-group class="grouping on">
            <van-field placeholder="请选择您的目标职能" v-model="intention_career_name" @click="pickerType(1)" readonly />
            <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
          </van-cell-group>
        </div>
      </div>
      <!-- 求职岗位 -->
      <div class="task_f">
        <div class="input-box input-mt on">
          <van-cell-group class="grouping on">
            <van-field placeholder="请选择您的目标职位" v-model="intention_job_name" @click="intentionJob" readonly />
            <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
          </van-cell-group>
        </div>
      </div>
    </div>
    <div class="consent_bottom">
      <a v-if="isShow" class="next xz" @click="choose_click">确定</a>
      <a v-else class="next">确定</a>
    </div>
    <van-popup v-model="picker_show" position="bottom">
      <!-- 意向行业 -->
      <van-picker v-if="picker_type==1" show-toolbar :columns="intention_career_group" @cancel="cancel" @confirm="confirm" />
      <!-- 求职岗位 -->
      <van-picker v-if="picker_type==2" show-toolbar :columns="intention_job_group" @cancel="cancel" @confirm="confirm" />
    </van-popup>
  </div>
</template>
<script>
import {
  getprofession,
  setprofession
} from "@/api/totoring"
import {
  statistics
} from "@/api/public";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        arrow: false,
        intention_career_name: '',
        intention_job_name: '',
        picker_show: false,
        picker_type: 0,
        intention_career_group: [],
        intention_job_group: [],
        intention_career_id: '',
        intention_job_id: '',
        intention_group: []
      }
    },
    computed: {
      isShow() {
        if (!this.$Validator.isEmpty(this.intention_career_name) && !this.$Validator.isEmpty(this.intention_job_name)) {
          return true
        }
        return
      }
    },
    methods: {
      pullData() {
        getprofession()
          .then((data) => {
            shareCon("totoring", this);
            this.body_show = true;
            this.intention_group = data;
            for (let arg of data) {
              this.intention_career_group.push(arg.name);
            }
          })
      },
      // 判断弹出是什么选择框
      pickerType(type) {
        // 1 目标职能 2 目标职位
        this.picker_type = type;
        this.picker_show = true;
      },
      intentionJob() {
        if (!this.$Validator.isEmpty(this.intention_career_name)) {
          this.pickerType(2);
        } else {
          this.$toast('请先选择职能，方可选择职位');
        }
      },
      // 弹出选择框  1 意向行业、2 求职岗位
      confirm(data) {
        if (this.picker_type == 1) {
          this.intention_career_name = data;
          this.pickerCareer(data);
          this.intention_job_name = '';
        } else if (this.picker_type == 2) {
          this.intention_job_name = data;
          this.pickerJob(data);
        }
        this.picker_show = false;
      },
      pickerCareer(val) {
        for (let args of this.intention_group) {
          if (val == args.name) {
            this.intention_career_id = args.id;
            for (let arg of args.job) {
              this.intention_job_group.push(arg.name);
            }
            return;
          }
        }
      },
      pickerJob(val) {
        for (let args of this.intention_group) {
          for (let arg of args.job) {
            if (val == arg.name) {
              this.intention_job_id = arg.id;
              return;
            }
          }
        }

      },
      choose_click() {
        setprofession({
          professionid: this.intention_career_id,
          jobid: this.intention_job_id
        })
        .then((data) => {
        	 if(typeof data !== 'string'){
             this.$router.push({path:"/mentor_list",query:{"position":this.intention_job_name}});
            }else {
              location.href = data;
            }

        })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.task {
  padding: 0 30px;
}

.task_e {
  margin: 0 auto;
  margin-top: 40px;
  text-align: justify;
  color: #EB5032;
  font-size: 32px;
  line-height: 48px;
}

.task_f {
  margin-top: 30px;
  .label {
    span {
      font-size: 24px;
      color: #666;
    }
    label {
      border-bottom: 1px solid #EB5032;
    }
  }
  input {
    font-size: 26px;
  }
  .input-box {
    .son input {
      padding-left: 20px;
    }
  }
  .input-box.on {
    padding-left: 0;
    background-color: transparent
  }
  .input-box.upload-on {
    background-color: transparent;
    height: auto;
    margin-top: 20px;
    a {
      display: block;
      width: 120px;
      height: 120px;
      float: left;
      clear: both;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      line-height: 120px;
      color: #666;
    }
  }
  .is-show {
    background-color: #ffffff;
    font-size: 26px;
    margin-top: 0;
    height: 70px;
    padding: 0 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 8px;
    margin-top: 20px;
  }
}

.consent_bottom {
  position: fixed;
  bottom: 20px;
  height: 120px;
  background: #f0f0f0;
  width: 100%;
  .next {
    width: 174px;
    height: 66px;
    line-height: 66px;
    background: rgba(204, 204, 204, 1);
    border-radius: 33px;
    margin: 0 auto;
    margin-top: 138px;
    color: #fff;
    font-size: 34px;
    text-align: center;
    margin-top: 55px;
    display: block;
  }
  .xz {
    background-color: #EB5032
  }
}
</style>
<style>
.grouping .van-cell .van-cell__value input {
  height: 90px
}

.grouping .choose_lable {
  top: 40px
}
</style>
